module.exports = __webpack_public_path__ + "media/images/menu/sol-6457f71770bd273fc3b3357aa757b685.jpg";